import { render, staticRenderFns } from "./ClinicInfo.vue?vue&type=template&id=fe3b6188&"
import script from "./ClinicInfo.vue?vue&type=script&lang=ts&"
export * from "./ClinicInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ClinicInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports